import React from "react";
import { Layers, Droplets, ShieldCheck, Printer } from "lucide-react";

// SEO-focused capabilities section: factual, keyword-rich content describing
// what Crimson Inks manufactures, written for both search engines and AI crawlers.
const capabilities = [
  {
    icon: Printer,
    title: "Gravure Printing Inks & Coatings",
    text: "UV and LED curable inks and coatings engineered for gravure printing on films, paper and metallised substrates, with controlled rheology and low solvent retention.",
  },
  {
    icon: Layers,
    title: "Screen Printing UV/LED Coatings",
    text: "High-build UV and LED curable coatings for screen printing applications, delivering strong adhesion, gloss and rub resistance across diverse substrates.",
  },
  {
    icon: Droplets,
    title: "Offset Printing Coatings",
    text: "UV and LED curable overprint varnishes and coatings for offset printing that cure instantly, enhance finish and improve production throughput.",
  },
  {
    icon: ShieldCheck,
    title: "Flexo & Security Coatings",
    text: "UV and LED curable coatings for flexo printing plus specialised security inks and coatings for brand protection and anti-counterfeiting.",
  },
];

const CapabilitiesSection = () => {
  return (
    <section
      id="capabilities"
      className="section-padding bg-gray-50 reveal"
      data-testid="capabilities-section"
    >
      <div className="container-custom">
        <div className="max-w-3xl mb-12">
          <span className="text-[#8B1538] font-semibold text-sm uppercase tracking-wider">
            Manufacturing Capabilities
          </span>
          <div className="h-1 w-20 bg-[#8B1538] mt-2 mb-6"></div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
            UV & LED Curable Ink and Coating Manufacturer in India
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Crimson Inks Private Limited is an ISO 9001:2015 certified
            manufacturer of UV and LED curable inks and coatings, serving the
            printing and packaging industry from Kanpur, Uttar Pradesh. Since
            2000, we have developed and supplied advanced curable coatings for
            gravure, screen, offset and flexo printing processes, helping
            printers and converters across India improve print quality,
            curing speed and sustainability.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {capabilities.map((cap, index) => (
            <div
              key={index}
              className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              data-testid={`capability-card-${index}`}
            >
              <div className="bg-red-100 p-3 rounded-lg inline-flex mb-4">
                <cap.icon className="h-6 w-6 text-[#8B1538]" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                {cap.title}
              </h3>
              <p className="text-sm text-gray-600 leading-relaxed">{cap.text}</p>
            </div>
          ))}
        </div>

        <p className="text-base text-gray-600 leading-relaxed max-w-4xl mt-12">
          As a trusted UV ink manufacturer and LED curable coatings supplier in
          Kanpur, Crimson Inks offers custom formulations tailored to specific
          substrates including paper, PVC, polycarbonate, metallised polyester
          and metal sheets. Our technical team also maintains a detailed gravure
          printing troubleshooting guide to support press-side problem solving.
        </p>
      </div>
    </section>
  );
};

export default CapabilitiesSection;
